import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { createPortal } from 'react-dom';
import { getSnapshot, subscribe } from './dialogs-store';
export const GlobalDialogComponent = () => {
    const { items } = React.useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
    return createPortal(_jsx(_Fragment, { children: items.map(d => (_jsx(React.Fragment, { children: d.component }, d.id))) }), document.body);
};
//# sourceMappingURL=GlobalDialogComponent.js.map